import React, { FC, ReactElement } from 'react';
import { Box, Flex, IconButton, Stack, useColorMode } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';
import { CloseIcon } from '@chakra-ui/icons';

import { AccessibilityForm } from '../components';

interface MobileNavOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MobileNavOverlay: FC<MobileNavOverlayProps> = ({
  isOpen,
  onClose,
}): ReactElement => {
  const modeProps = useColorMode();
  return (
    <Box
      boxShadow="xl"
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      margin="auto"
      marginTop="10vh"
      width="90%"
      height="380px"
      zIndex="overlay"
      backgroundColor={mode('white', 'black')(modeProps)}
      borderColor={mode('brand.lightBase', 'white')(modeProps)}
      borderWidth="1px"
      borderRadius="6px"
      display={isOpen ? 'block' : 'none'}
    >
      <Flex justify={'flex-end'}>
        <IconButton
          mt={5}
          mr={5}
          onClick={onClose}
          color="grey"
          aria-label="Close Mobile Navigation"
          icon={<CloseIcon />}
          bg="transparent"
          fontSize="18px"
          marginTop="4px"
          marginRight="4px"
        />
      </Flex>
      <Box mx="auto" maxWidth="85%">
        <Stack spacing="30px">
          <AccessibilityForm />
        </Stack>
      </Box>
    </Box>
  );
};
